<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="stylus">
#app {
  height 100%
}

body {
  overflow: auto;
}

html, body {
  -webkit-overflow-scrolling touch
}
</style>



// WEBPACK FOOTER //
// src/App.vue